// @ts-strict

/**
 * Created by stanleyw on 1/30/2018.
 */
import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { LMUrlUtilService } from '@services/utils/lm-url-util.service';
import { AppConstants } from '@utils/app.constants';
import { LMLoggerService } from './lm-logger.service';
import { Observable, throwError } from 'rxjs';
import { catchError, map } from 'rxjs/operators';

@Injectable()
export class LMAuditLogService {

  // This service should not include any state.

  constructor( private http: HttpClient,
    private lmUrlUtilService: LMUrlUtilService,
    private lmLoggerService: LMLoggerService) {
  }

  getAuditLogData(url: string): Observable<LMAuditData> {
    const params: LMUrlParams = { pageop: 'load' };
    return this.page(this.lmUrlUtilService.updateUrlParams(url, params));
  }

  /**
   *
   * @param url
   * @returns
   */
  private page(url: string): Observable<LMAuditData> {
    return this.http.get(url).pipe(
      map((response: any) => {
        if (response.status !== AppConstants.STATUS_COMPLETED) {
          throw new Error(response.status || 'Server error');
        }
        return response.auditData;
      }),
      catchError(error => {
        this.lmLoggerService.error(error);
        return throwError(error || 'Server error');
      }));
  }
}

